module.exports = __webpack_public_path__ + "img/Michel.22664c5f.jpeg";